import { render, staticRenderFns } from "./EligibilityDialogWrapper.vue?vue&type=template&id=87cf25aa&scoped=true&"
import script from "./EligibilityDialogWrapper.vue?vue&type=script&lang=js&"
export * from "./EligibilityDialogWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cf25aa",
  null
  
)

export default component.exports